import { connect } from 'react-redux';
import { Locales } from 'constants/app.constant';
import { appSelectors } from 'redux/ducks/app';
import { withChartLayout } from 'components/common';
import AdvanceDirective from 'components/features/chart/special-charts/advance-directive/AdvanceDirective';

const AdvanceDirectiveContent = withChartLayout('Advance Directive')(AdvanceDirective);

export interface AdvanceDirectivePageProps {
  locale: Locales;
}

export const BaseAdvanceDirectivePage = ({ locale }: AdvanceDirectivePageProps) => (locale === Locales.EN_US ? <AdvanceDirectiveContent /> : null);

const mapStateToProps = (state) => ({
  locale: appSelectors.getLocale(state)
});

export default connect(mapStateToProps)(BaseAdvanceDirectivePage);
